import { EntityState } from '@ngrx/entity';
import { IDocument } from 'src/app/models/document';
import { documentLibraryAdapter } from '../document-library/selectors/document-library.selectors';
import { ClientEntity } from 'src/app/models/clients';

export interface IDocumentLibraryState extends EntityState<IDocument> {
    loading: boolean;
    clientEntityIds: ClientEntity[];
}

export const initialDocumentLibraryState = documentLibraryAdapter.getInitialState({
    loading: false,
    clientEntityIds: [],
});
